import React from 'react';
import './infoCard.scss';
import {InfoCardType} from 'models';
import {HashLink} from 'react-router-hash-link';

export const InfoCard: React.FC<InfoCardType> = ({id, date, heading, description, link, image}) => {
    console.log({image})
    return (
        <div className={'info-card'}>
            <div className="info-card_img">
                <img src={image} alt=""/>
            </div>
            <div className="info-card_text">
                <span>{date}</span>
                <h1>{heading}</h1>
                <p>{description}</p>
            </div>
            <div className="info-card_cta">
                <div>
                    <HashLink smooth to={`/${link}/${id}`}><p>Read More</p></HashLink>
                </div>
            </div>
        </div>
    );
};

export default InfoCard;
